// extracted by mini-css-extract-plugin
export var article_root = "privacy-policy-module--article_root--3yjit";
export var chapter = "privacy-policy-module--chapter--eivCI";
export var chapter_root = "privacy-policy-module--chapter_root--1uMSf";
export var root = "privacy-policy-module--root--1ylTC";
export var section = "privacy-policy-module--section--1bCxZ";
export var section_root = "privacy-policy-module--section_root--1hFle";
export var title = "privacy-policy-module--title--2Cc_U";
export var title_root = "privacy-policy-module--title_root--2DCSe";